module.exports = __webpack_public_path__ + "static/media/24-3.fdec3058.mp3";